import React, {
  useRef,
  useState,
  // useEffect
} from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import TableContainer from "@mui/material/TableContainer";

import Table from "@mui/material/Table";
import {
  validaSoloNumero,
  // validaMonto, formatoMonto, seleccionarCampo,
  EnhancedTableHead,
  formatMoneda,
  getComparator,
  stableSort,
} from "../../util/varios";

import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import TablePagination from "@mui/material/TablePagination";
import moment from "moment";
import useTableFijo from "../useTableFijo";
import CatalogoProvFondoTer2 from "../../catalogos/catalogoProveedorFondoTer2";

import ValidarUsuario from "../comun/modalValidarUsuario";
import { numeroaLetra } from "../../util/NumeroaLetra";

import {
  InfoButton,
  SuccessButton,
  DangerButton,
  WarningButton,
} from "../../ui/buttons/Button";
import { Input, SearchInput, Textarea } from "../../ui/inputs/Input";

export const ModalEnterarFondosTerceros = (props) => {
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° Orden",
      width: "60px",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Beneficiario",
      width: "250px",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Monto Orden",
      width: "100px",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Tipo Retencion",
      width: "200px",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Monto Retenido",
      width: "100px",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Fecha",
      width: "100px",
      textAlign: "center",
    },
  ];

  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const ip = JSON.parse(localStorage.getItem("ip"));
  const mac = JSON.parse(localStorage.getItem("mac"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  //const norden = espiritu === 0 || espiritu === 2 || espiritu === 3 || espiritu === 4 ? false: true;
  const norden = true;
  const anioefis = JSON.parse(localStorage.getItem("efiscalanio"));
  // const liquidador = JSON.parse(localStorage.getItem('liquidador'));
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [activate, setActivate] = useState(false);
  // const [deshabilitado, setDeshabilitado] = useState(false);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [visible, setVisible] = useState("hidden");
  const [datospre, setDatospre] = useState([]);
  const [valida, setValida] = useState([]);
  const [depart, setDepart] = useState(null);
  const [tip, setTip] = useState(null);
  const [ticomp, setTicomp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [pucc, setPucc] = useState(0);
  const [mostrar5, setMostrar5] = useState(false);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selectedItems, setSelectedItems] = useState([]);
  // const [dense, setDense] = useState(false);
  const [ultimo, setUltimo] = useState(false);
  const [idOrden, setIdOrden] = useState();
  const [habiCod, setHabicod] = useState(true);
  const [habiFecha, setHabiFecha] = useState(false);
  const [habiProv, setHabiProv] = useState(true);
  const [modifi, setModifi] = useState(false);
  const [proce, setProce] = useState(false);
  const [mostrarUsuario, setMostrarUsuario] = useState(false);
  const [desde, setDesde] = useState(0);
  const [habiConcep, setHabiConcep] = useState(false);
  const [cambioDatos, setCambioDatos] = useState(false);
  const [llamado, setLlamado] = useState(0);
  const [cambiarDatos, setCambiarDatos] = useState(false);
  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [codigo, setCodigo] = useState(0);
  const [titulo, setTitulo] = useState("");
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtFechaOP = useRef();
  const txtCodProve = useRef();
  const txtRazonProve = useRef();
  const txtObservacionOP = useRef();
  const txtMontoRetenido = useRef();
  const txtConcepto = useRef();
  const txtCodigo = useRef();
  const [selected, setSelected] = useState([]);

  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, records.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const {
    // TblContainer,
    // TblHead,
    // TblPagination,
    // recordsAfterPagingAndSorting
  } = useTableFijo(records, headCells, filterFn, 220);

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleSelectAllClick = (event, cual) => {
    if (props.operacion === 1) {
      event.preventDefault();
      if (event.target.checked) {
        const newSelecteds = records.map((item) => item);
        setSelected(newSelecteds);
        setSelectedItems(newSelecteds);
        txtMontoRetenido.current.value = formatMoneda(
          newSelecteds
            .reduce((a, b) => parseFloat(a) + parseFloat(b.ret_monto), 0)
            .toString()
            .replace(",", "")
            .replace(".", ","),
          ",",
          ".",
          2
        );
        return;
      } else {
        setSelected([]);
        setSelectedItems([]);
        txtMontoRetenido.current.value = "0,00";
      }
    }
  };

  const handleClick = (event, data) => {
    if (props.operacion === 1) {
      const { idordenpago } = data;
      let newSelected = [];
      let seleccionados = selectedItems;
      const selectedIndex = selected.indexOf(data);

      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, data);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1)
        );
      }
      setSelected(newSelected);
      if (selectedItems.some((item) => item.idordenpago === idordenpago)) {
        setSelectedItems(
          selectedItems.filter((item) => item.idordenpago !== idordenpago)
        );
        seleccionados = selectedItems.filter(
          (item) => item.idordenpago !== idordenpago
        );
      } else {
        setSelectedItems([...selectedItems, data]);
        seleccionados = [...selectedItems, data];
      }
      txtMontoRetenido.current.value = formatMoneda(
        seleccionados
          .reduce((a, b) => parseFloat(a) + parseFloat(b.ret_monto), 0)
          .toString()
          .replace(",", "")
          .replace(".", ","),
        ",",
        ".",
        2
      );
    }
  };

  const isSelected = (idordenpago) => {
    for (let i = 0; i < selected.length; i++) {
      if (selected[i].idordenpago === idordenpago) {
        return true;
      }
    }
    return null;
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const seleccionaUltimoId = () => {
    let campos =
      (props.norden ? "numordenpago" : "idordenpago") + " AS ultimoid";
    let nomtab = "ordenpago";
    let condi =
      "idefiscal=" +
      idefiscal +
      (props.norden ? " AND (tipo = 2 OR tipo = 3)" : "");
    let orden =
      (props.norden ? "numordenpago" : "idordenpago") + " DESC LIMIT 1";

    let endpoint =
      op.conexion +
      `/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setUltimo(parseInt(response.data[0].ultimoid));
            setHabicod(false);
            txtCodigo.current.value = parseInt(response.data[0].ultimoid) + 1;
          } else {
            setUltimo(0);
            setHabicod(false);
            txtCodigo.current.value = 1;
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarIdOrden = () => {
    let campos = "idordenpago";
    let nomtab = "ordenpago";
    let condi = "idefiscal=" + idefiscal;
    let orden = "idordenpago DESC LIMIT 1";

    let endpoint =
      op.conexion +
      `/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setIdOrden(parseInt(response.data[0].idordenpago) + 1);
          } else {
            setIdOrden(parseInt(1));
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFechaOP.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    } else if (
      new Date(txtFechaOP.current.value).getFullYear() !==
      anioefis
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    } else if (txtConcepto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa el Concepto",
        icono: "informacion",
      });
      sigue = false;
      txtConcepto.current.focus();
    } else if (txtMontoRetenido.current.value.trim() === "0,00") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Monto total retenido no Debe ser Igual a Cero",
        icono: "informacion",
      });
      sigue = false;
    }
    if (sigue) {
      if (props.operacion === 1) {
        if (ultimo + 1 !== parseInt(txtCodigo.current.value)) {
          setDesde(4);
          setMensajesino({
            mostrar: true,
            titulo: "Confirmación.",
            texto:
              "El Código de la Orden no corresponde al proximo número disponible, Desea Continuar?",
            icono: "confirmacion",
          });
        } else {
          crearreversar();
        }
      } else {
        crearreversar();
      }
    }
  };

  const cancelar = () => {
    if (cambioDatos) {
      blanquear();
      props.onHideRenderizar();
      props.onHideCancelar();
    } else {
      blanquear();
      props.onHideCancelar();
    }
  };

  const blanquear = () => {
    setRecords([]);
    setVisible("hidden");
    setDatospre([]);
    setActivate(false);
    setChek(0);
    setValida([]);
    setDepart(null);
    setTip(null);
    setUbi(null);
    setPucc(0);
    setData([]);
    setTicomp(null);
    setBody(null);
    setCodigo(0);
    setTitulo("");
    setActivo(true);
    setHabicod(true);
    setHabiFecha(false);
    setHabiProv(true);
    setCambioDatos(false);
    setModifi(false);
    setProce(false);
    setHabiConcep(false);
    setSelected([]);
    setSelectedItems([]);
    setRowsPerPage(10);
    setPage(0);
  };
  // const opciones = (ope, index) => (event) => {

  //     event.preventDefault();
  //     /*         blanquearCampos(); */

  //     if (ope === 1) {

  //         setMostrar5(true);
  //         setOperacion(1);
  //         /*     blanquearCampos()
  //   */
  //     } else {

  //     }

  // }
  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      //procesarCambioFechaReverso();
    } else if (desde === 2) {
      imprimirOrdenPago();
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto:
          "Orden de Pago " +
          txtCodigo.current.value +
          " Registrada Correctamente",
        icono: "exito",
      });
    } else if (desde === 3) {
      imprimirOrdenPago();
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: "Orden de Pago Registrada Correctamente",
        icono: "exito",
      });
    } else if (desde === 4) {
      crearreversar();
    } else {
      Actualizar();
    }
  };

  const crearreversar = () => {
    let datosorden = [];
    datosorden.push({
      concepto: txtConcepto.current.value.trim(),
      idproveedor: txtCodProve.current.value,
      observ: txtObservacionOP.current.value.trim(),
      montoorden: parseFloat(
        txtMontoRetenido.current.value.replace(/\./g, "").replace(",", ".")
      ),
    });
    setBody({
      operacion: props.operacion,
      idordenp: txtCodigo.current.value,
      idorden: idOrden,
      norden: props.norden,
      idefi: idefiscal,
      idusuario: idusuario,
      fecha: txtFechaOP.current.value,
      espiritu: espiritu,
      fechasis: fechaSistema,
      datosordenp: datosorden,
      datosrete: selectedItems,
    });

    let msg = "";
    setDesde(0);
    if (props.operacion === 1) {
      msg = "Esta Seguro de Registrar estos Datos?.";
    } else if (props.operacion === 2) {
      msg = "Esta Seguro de Reversar esta Orden de Pago?.";
    } else if (props.operacion === 3) {
      msg = "Esta Seguro de Eliminar esta Orden de Pago?.";
    }
    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: msg,
      icono: "confirmacion",
    });
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/administracion/crearreversarordenpagoftercero`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (props.operacion === 1) {
            setDesde(2);
            setMensajesino({
              mostrar: true,
              titulo: "Confirmación.",
              texto: "Desea Imprimir En este Momento la Orden de Pago?",
              icono: "confirmacion",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Orden de Pago " +
                txtCodigo.current.value +
                " Reversada Correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Orden de Pago " +
                txtCodigo.current.value +
                " Eliminada Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const handleCloseNo = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 2) {
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto:
          "Orden de Pago " +
          txtCodigo.current.value +
          " Registrada Correctamente",
        icono: "exito",
      });
    } else if (desde === 4) {
      txtCodigo.current.focus();
    }
  };

  const imprimirOrdenPago = () => {
    var reporte = "";
    if (props.norden) {
      reporte = "ForPagoTerceroNumOrden";
    } else {
      reporte = "ForPagoTercero";
    }
    var sql = "'" + idOrden + "'";
    var sql2 = "0";
    var sql1 =
      numeroaLetra(txtMontoRetenido.current.value.trim().replace(/\./g, "")) +
      " Bs.";
    var concepto = txtConcepto.current.value;
    var Beneficiario = txtRazonProve.current.value;
    var fecha = moment.utc(txtFechaOP.current.value).format("DD/MM/YYYY");
    var monto = txtMontoRetenido.current.value;

    sql = idOrden;
    window.open(
      op.reportes +
        "/administracionTesoreria?" +
        "reporte=" +
        reporte +
        "&ID=" +
        sql +
        "&ENLETRAS=" +
        sql1 +
        "&VALIDO=" +
        sql2 +
        "&CONCEPTO=" +
        concepto +
        "&BENEFICIARIO=" +
        Beneficiario +
        "&FECHA=" +
        fecha +
        "&MONTO=" +
        monto +
        "&VIENE=" +
        espiritu +
        "&EFISCAL=" +
        idefiscal,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };
  // const BaseDatos = (data) => {
  //     if (data.length > 0) {
  //         setActivo(false);
  //         setValida(1);
  //     } else {
  //         setActivo(true);
  //         setValida(0);
  //     }
  //     setData(data);
  //     console.log(data);
  // }
  const seleccionarRerenciones = (idproveedor, idorden) => {
    setMostrar5(false);
    let endpoint;
    if (props.operacion === 1) {
      if (norden) {
        endpoint = `${op.conexion}/api/administracion/seleccioanrretenciones1?idproveedor=${idproveedor}&idefiscal=${idefiscal}`;
      } else {
        endpoint = `${op.conexion}/api/administracion/seleccioanrretenciones?idproveedor=${idproveedor}&idefiscal=${idefiscal}`;
      }
    } else {
      if (norden) {
        endpoint = `${op.conexion}/api/administracion/seleccionarretencionesxorden1?idorden=${idorden}&idefiscal=${idefiscal}`;
      } else {
        endpoint = `${op.conexion}/api/administracion/seleccionarretencionesxorden?idorden=${idorden}&idefiscal=${idefiscal}`;
      }
    }
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarProveedor = (id, tecla, idorden) => {
 
    
    setMostrar5(false);
    let endpoint = `${op.conexion}/api/administracion/catalogoprovfondterceid?id=${id}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
         
          if (response.data.idproveedor) {
            txtCodProve.current.value = response.data.idproveedor;
            txtRazonProve.current.value =
              response.data.rif + " - " + response.data.razonsocial;
            if (tecla === 13) {
              txtObservacionOP.current.focus();
            }
            seleccionarRerenciones(response.data.idproveedor, idorden);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡Código i/o Proveedor, No esta Registrado!",
              icono: "error",
            });
            txtCodProve.current.value = "";
            txtRazonProve.current.value = "";
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleProveedor = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProveedor(event.target.value, event.which, idOrden);
      }
    }
  };
  const validarProveedor = (idprov, idcdprov, nomb) => {
    setMostrar5(false);
    txtCodProve.current.value = idprov;
    seleccionarProveedor(idprov, 13, idOrden);
  };
  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.name === "codigo") {
          txtFechaOP.current.focus();
        } else if (event.target.name === "idprove") {
          txtObservacionOP.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  const cambiarConcepto = () => {
    setDesde(0);
    setMostrarUsuario(true);
  };
  const validarModificarConcepto = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código de la Orden de Pago no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtFechaOP.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    } else if (txtConcepto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El concepto de la Orden de Pago no puede estar en blanco",
        icono: "informacion",
      });
      sigue = false;
      txtConcepto.current.focus();
    } else if (
      new Date(txtFechaOP.current.value).getFullYear() !==
      anioefis
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    } 
    if (sigue) {
      let body = {
        idordenpnue: txtCodigo.current.value.trim(),
        idorden: idOrden,
        norden: props.norden,
        observ: txtObservacionOP.current.value.trim(),
        concepto: txtConcepto.current.value,
        dfecha: txtFechaOP.current.value,
        idefi: idefiscal,
        espiritu: espiritu,
        idusu: idusuario,
        fechasis: fechaSistema,
        dirip: ip === "" || ip === null ? "0.0.0.0" : ip,
        dirmac: mac === "" || mac === null ? "0.0.0.0" : mac,
      };
      procesarCambio(body);
    }
  };
  const procesarCambio = (body) => {
    let endpoint = `${op.conexion}/api/administracion/modificarconceptoordenpagoftercero`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Se Generaron Cambios Satisfactoriamente",
            icono: "exito",
          });
          setModifi(true);
          setProce(false);
          setHabiConcep(false);
          setHabiFecha(false);
          setHabicod(true);
          setCambioDatos(true);
          if (!norden) {
            setIdOrden(txtCodigo.current.value);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const aceptaClaveSupervisor = () => {
    setMostrarUsuario(false);
    if (desde === 0) {
      setModifi(false);
      setProce(true);
      setHabiFecha(true);
      setHabiConcep(true);
      setHabicod(false);
    } else if (desde === 1) {
      setLlamado(3);
      setCambiarDatos(true);
    } else if (desde === 5) {
      setModifi(false);
      setProce(false);
    }
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setModifi(false);
        if (props.operacion !== 1) {
          if (props.operacion === 4 && props.ordenp.reversado === 0) {
            setModifi(true);
          }
          setHabicod(true);
          txtCodigo.current.value = norden
            ? props.ordenp.numordenpago
            : props.ordenp.idordenpago;
          setCodigo(props.ordenp.idordenpago);
          setIdOrden(props.ordenp.idordenpago);
          txtFechaOP.current.value = moment.utc(props.ordenp.fecha).format(
            "YYYY-MM-DD"
          );
          txtObservacionOP.current.value =
            props.ordenp.observacion !== null
              ? props.ordenp.observacion.trim()
              : "";
          txtConcepto.current.value = props.ordenp.conceptoorden.trim();
          setHabiFecha(false);
          setHabiConcep(false);
          setHabiProv(false);
          txtMontoRetenido.current.value = formatMoneda(
            props.ordenp.montoordenpago
              .toString()
              .replace(",", "")
              .replace(".", ","),
            ",",
            ".",
            2
          );
          seleccionarProveedor(
            props.ordenp.idproveedororden,
            0,
            props.ordenp.idordenpago
          );
        } else {
          seleccionaUltimoId();
          seleccionarIdOrden();
          setHabicod(false);
          setHabiFecha(true);
          setHabiConcep(true);
          txtFechaOP.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
        }
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>
          {props.titulo +
            (props.operacion === 1 && ultimo
              ? ", Ultima procesada: " + ultimo
              : "")}
        </h3>
        <a type="button" onClick={cancelar}>
          salir<i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <ValidarUsuario
          show={mostrarUsuario}
          onHideCancela={() => {
            setMostrarUsuario(false);
            setDesde(0);
          }}
          onHideConfirmar={aceptaClaveSupervisor}
          llamado={0}
        />
        <div
       
          className="col-12 m-0 p-0 d-flex flex-wrap align-items-center"
        >
          {props.ordenp && props.ordenp.reversado > 0 && (
            <div className="col-12 input-group input-group-sm m-0 p-0">
              <font color="red" size="1">
                <h1 align="center">
                  <i>¡ La Orden de Pago está Reversada !</i>
                </h1>
              </font>
            </div>
          )}
          <div className="col-12 col-lg-5 p-0 py-lg-2 pr-lg-2 m-0 mb-2 mb-lg-0 d-flex flex-lg-column gap-1">
            <div className="col-3 col-lg-3 m-0 p-0">
              <Input
                label="Código"
                name="codigo"
                onKeyUp={handleInputNumChange}
                disabled={habiCod}
                id="inputDireccion"
                ref={txtCodigo}
              />
            </div>
            <div className="col-8 col-lg-6 m-0 p-0 pl-2 pl-lg-0 ">
              <Input
                label="Fecha de la Orden"
                type="date"
                defaultValue={moment.utc(fechaSistema).format("DD/MM/YYYY")}
                disabled={!habiFecha}
                id="inputDireccion"
                ref={txtFechaOP}
              />
            </div>
          </div>
          <fieldset className="col-12 col-lg-7 m-0 p-2 d-flex border-azul rounded">
            <legend className="float-none m-0 w-auto fw-bold fw-bold">
              Beneficiario
            </legend>
            <div className="col-3 m-0 p-0">
              <SearchInput
                label="Código:"
                autoComplete="off"
                disabled={!habiProv}
                onKeyUp={handleProveedor}
                onBlur={handleInputNumChange}
                name="idprove"
                id="inputDireccion"
                disabledButton={!habiProv}
                onClickButton={() => {
                  setMostrar5(true);
                }}
                ref={txtCodProve}
              />
            </div>
            <Input
              disabled={true}
              name="observacion"
              id="inputDireccion"
              ref={txtRazonProve}
            />
          </fieldset>
          <div className="col-12 m-0 my-2 p-0">
            <Textarea
              label="Observación:"
              style={{ height: 70 }}
              name="observacion"
              onChange={onChange}
              disabled={!habiConcep}
              id="inputDireccion"
              ref={txtObservacionOP}
            />
            {modifi === true && (
              <WarningButton
                icon="fa-edit"
                onClick={cambiarConcepto}
              ></WarningButton>
            )}
            {proce === true && (
              <SuccessButton onClick={validarModificarConcepto}>
                Procesar
              </SuccessButton>
            )}
          </div>
          <div className="col-12 m-0 mb-2 p-0">
            <Textarea
              label="Concepto/Detalle:"
              type="textarea"
              style={{ height: 70 }}
              name="observacion"
              onChange={onChange}
              disabled={!habiConcep}
              id="inputDireccion"
              ref={txtConcepto}
            />
          </div>
          <TableContainer>
            <Table>
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={records.length}
                headCells={headCells}
              />
            </Table>
          </TableContainer>
          <Paper
            style={{
              width: "100%",
              marginBottom: "10px",
              maxHeight: "250px",
              overflowY: "scroll",
            }}
          >
            <TableContainer>
              <Table
                className={{
                  minWidth: 750,
                }}
                aria-labelledby="tableTitle"
                size="small"
                aria-label="enhanced table"
              >
                <tbody>
                  {stableSort(
                    filterFn.fn(records),
                    getComparator(order, orderBy)
                  )
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.idordenpago);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <tr
                          hover
                          onClick={(event) => handleClick(event, row)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.idordenpago}
                          selected={isItemSelected}
                        >
                          <td style={{ width: '20px' }} padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              color="primary"
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          </td>

                          <td
                            style={{
                              textAlign: "center",
                              fontSize: "10px",
                              width: "60px",
                            }}
                          >
                            {" "}
                            {norden ? row.numordenpago : row.idordenpago}{" "}
                          </td>
                          <td
                            style={{
                              textAlign: "left",
                              fontSize: "10px",
                              width: "250px",
                            }}
                            className='pl-2'
                          >
                            {row.razonsocial}
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              fontSize: "10px",
                              width: "100px",
                            }}
                          >
                            {formatMoneda(
                              row.montoordenpago
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              fontSize: "10px",
                              width: "200px",
                            }}
                            //className='pl-3'
                          >
                            {row.descripcion}
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              fontSize: "10px",
                              width: "100px",
                            }}
                          >
                            {formatMoneda(
                              row.ret_monto
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              fontSize: "10px",
                              width: "100px",
                            }}
                          >
                            {moment.utc(row.ret_fecha).format("DD/MM/YYYY")}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </TableContainer>
          </Paper>
          <TablePagination
            rowsPerPageOptions={[10, 15, 20]}
            component="div"
            count={records.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <div className="col-md-8"></div>
          <div className="col-3 m-0 ml-auto p-0">
            <Input
              label="Total Retenciones"
              inputClassName="text-end"
              defaultValue={"0,00"}
              name="observacion"
              disabled={true}
              id="inputDireccion"
              ref={txtMontoRetenido}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={onChangeValidar}
          disabled={props.operacion === 4 ? true : false}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
        {props.ordenp && props.operacion !== 1 && (
          <InfoButton onClick={imprimirOrdenPago} icon="fa-print">
            Imprimir
          </InfoButton>
        )}
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={handleCloseNo}
        onHideSi={handleCloseSi}
      />

      <CatalogoProvFondoTer2
        show={mostrar5}
        onHideCancela={() => {
          setMostrar5(false);
        }}
        onHideAceptaCatalogo={validarProveedor}
      />
    </Modal>
  );
};
